import React from "react";
import { Award, ExternalLink } from "lucide-react";

const Certifications = ({ theme, visibleSections, portfolioData }) => {
  const certifications = portfolioData.certifications || [];

  if (certifications.length === 0) {
    return null;
  }

  return (
    <section
      id="certifications"
      className={`mb-20 transition-opacity duration-1000 ${
        visibleSections.certifications ? "opacity-100" : "opacity-0"
      }`}
    >
      <h3 className="text-3xl font-bold mb-8 flex items-center">
        <Award className="mr-2" /> Certifications
      </h3>
      <div className="grid md:grid-cols-2 gap-8">
        {certifications.map((cert, index) => (
          <div
            key={index}
            className={`p-6 rounded-lg ${
              theme === "dark" ? "bg-gray-800" : "bg-gray-100"
            } transform transition duration-300 hover:scale-105 hover:shadow-lg ${
              cert.featured ? "ring-2 ring-blue-500" : ""
            }`}
          >
            <h4 className="text-xl font-semibold mb-2">{cert.name}</h4>
            <p className="text-sm mb-4">
              {cert.issuer}
              {cert.issuer && cert.date ? " • " : ""}
              {cert.date}
            </p>
            {cert.url && (
              <a
                href={cert.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:text-blue-600 flex items-center"
              >
                Verify Credential <ExternalLink size={16} className="ml-1" />
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
